module.exports = __webpack_public_path__ + "static/media/09n.aad8f997.svg";